import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllCategories, deleteCategory } from "./CategoryService";

export default function CategoryList(){
  const [categories,setCategories] = useState([]);
  const nav = useNavigate();

  useEffect(()=>{
     load(); 
  },[]);

  const load = async ()=>{
    const data = await getAllCategories();
    setCategories(data);
  };

  // ✅ ADD THIS
  const handleDelete = async (id, userId) => {
    if (!window.confirm("Delete this category?")) return;

    await deleteCategory(id, userId);

    // ✅ refresh UI
    load(); 
  };

  return (
    <div>
      <button onClick={()=>nav("new")}>➕ Add</button>

      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {categories.map((c) => (
            <tr key={c.id}>
              <td>{c.categoryName}</td>
              <td>{c.categoryType}</td>
              <td>{c.active ? "Yes" : "No"}</td>
              <td>
                <button onClick={() => nav(`edit/${c.id}`)}>✏️</button>

                {/* ✅ FIXED */}
                <button onClick={() => handleDelete(c.id, c.userId)}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
